import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  size = 'md'
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  const sizes = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-4xl',
    full: 'max-w-[95vw]'
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-1749" data-mp="3qkza9xlf4s6a">
      <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity" onClick={onClose} data-id="element-1750" data-mp="2k6hscxixae8g"></div>

      <div className={`
        relative w-full ${sizes[size]} bg-white rounded-2xl shadow-2xl transform transition-all flex flex-col max-h-[90vh]
      `} data-id="element-1751" data-mp="2f8geqs49n74d">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100" data-id="element-1752" data-mp="2n1h8o3v3tjmr">
          <h3 className="text-xl font-bold text-slate-900" data-id="element-1753" data-mp="284q9nvpce9xo">{title}</h3>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition-colors" data-id="element-1754" data-mp="2d433x1ijmjaa">
            <X className="h-5 w-5" data-id="element-1755" data-mp="243y0f2gh051e" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto custom-scrollbar" data-id="element-1756" data-mp="24594l3dtvet1">{children}</div>
      </div>
    </div>;
}